import { render, staticRenderFns } from "./DocumentFilters.vue?vue&type=template&id=61e8fbb6"
import script from "./DocumentFilters.vue?vue&type=script&lang=js"
export * from "./DocumentFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports